module.exports = __webpack_public_path__ + "img/no-data-5A.813fc7a5.png";